import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { Notification, NotificationCollection } from './notification.types';

const useNotificationData = (site: number, discipline: number) => {
  const getNotificationQuery = useCallback(
    (collection: NotificationCollection) =>
      collection?.find({
        selector: {
          $and: [{ site }, { discipline }, { isActive: true }],
        },
      }),
    [site, discipline],
  );

  const { result: notifications } = useRxData<Notification>(
    RxdbCollectionName.NOTIFICATION,
    getNotificationQuery,
  );
  const notificationList = notifications.sort((a, b) => {
    return new Date(b.datecreated) - new Date(a.datecreated);
  });
  const unreadNotificationList = notificationList.filter((item: Notification) => !item.isRead);

  const readNotificationList = notificationList.filter((item: Notification) => item.isRead);

  return {
    notificationList,
    unreadNotificationList,
    readNotificationList,
  };
};

export default useNotificationData;
